// prop-type is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid2";
import { styled } from "@mui/material/styles";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import { Avatar, Divider } from "@mui/material";
import MDAvatar from "components/MDAvatar";
import DetailList from "components/DetailList";
import { useEffect, useState } from "react";
import { areAllValuesEmpty } from "components/helper";

const Review = ({ formData, editPage = false }) => {
  const { values } = formData;
  const [facilityInfoData, setFacilityInfoData] = useState({});
  const [fields, setFields] = useState([]);

  useEffect(() => {
    if (values) {
      setFacilityInfoData({
        title: values?.title,
        openHours: values?.openHours,
        subHeader: values?.subHeader,
        ctaTitle: values?.ctaTitle,
        ctaLink: values?.ctaLink,
        description: values?.description,
        location: values?.location,
        file: values?.file,
      });
    }
  }, [values]);

  useEffect(() => {
    setFields([{ id: 0, title: "Other facility info", data: facilityInfoData }]);
  }, [facilityInfoData]);

  const BigAvatar = styled(Avatar)`
    width: 74px;
    height: 74px;
  `;

  return (
    <MDBox>
      <MDBox mt={1.625}>
        <Grid container spacing={3}>
          {!editPage ? (
            <Grid size={{ xs: 12, sm: 6 }}>
              {values?.image ? (
                <MDAvatar
                  src={URL.createObjectURL(values?.image)}
                  alt="profile-image"
                  size="xl"
                  sx={{ "& img": { height: "100%" } }}
                />
              ) : (
                <BigAvatar
                  alt="Change your profile photo"
                  src={URL.revokeObjectURL(values?.image)}
                  imgProps={{
                    style: {
                      maxHeight: "100%",
                      maxWidth: "100%",
                      objectFit: "cover",
                    },
                  }}
                />
              )}
            </Grid>
          ) : (
            ""
          )}
          {fields?.map((field, i) => (
            <Grid
              item
              key={field.id}
              size={{ xs: 12 }}
              sx={{
                display: areAllValuesEmpty(field.data) ? "none" : "flex",
                flexDirection: "column",
              }}
            >
              <DetailList data={field.data} title={field?.title} />
              {i + 1 !== fields?.length && (
                <div>
                  <Divider sx={{ height: "1px" }} />
                </div>
              )}{" "}
              {values?.file ? (
                <a
                  href={URL.createObjectURL(values?.file)}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ fontSize: "small", color: "gray" }}
                >
                  View Pdf
                </a>
              ) : (
                <p style={{ fontSize: "small" }}>No file selected</p>
              )}
            </Grid>
          ))}
        </Grid>
      </MDBox>
    </MDBox>
  );
};

// typechecking props for Review
Review.propTypes = {
  formData: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.func]).isRequired,
  editPage: PropTypes.bool,
};

export default Review;
